export default __webpack_public_path__ + "static/media/payment-step.c21cd294.svg";